export const paragraphSize = (size) => {
  switch(size) {
    case 'xs':
      return 12
    case 'sm':
      return 14
    case 'md':
      return 16;
    case 'lg':
      return 20;
    case 'xl':
      return 24;
    case 'xxl':
      return 28;
    default:
      return 20
  }
}

export const schedule = [
  {
    week: 1,
    title: "SEMANA 1 - 28 de Outubro a 03 de Novembro",
    subjects: [
      "Linguagens, Códigos e suas tecnologias","Ciências Humanas","Redação"
    ],
    startDate: "2024-10-28T00:00:00-03:00",
    endDate: "2024-11-03T23:59:59-03:00",
    days: [
      {
        date: "2024-10-28T00:00:00-03:00",
        title: "SEGUNDA - 28/10",
        ebookLink: "sos_aprova_dia_1",
        simulatedLink: "simulado-sos-2024-28-10",
        liveUrl: "eZRONvJoedA",
        asset: "thumb-seg-1",
        classes: [
          {
            class: "Geografia (Prof. Gegê)",
            hour: "2024-10-28T15:00:00-03:00",
            url: "eZRONvJoedA",
          },
          {
            class: "Português (Prof. Ricardinho)",
            hour: "2024-10-28T16:00:00-03:00",
            url: "eZRONvJoedA",
          },
          {
            class: "Geografia (Prof. Gegê)",
            hour: "2024-10-28T17:15:00-03:00",
            url: "eZRONvJoedA",
          },
          {
            class: "Sociologia (Profa. Daiana)",
            hour: "2024-10-28T18:15:00-03:00",
            url: "eZRONvJoedA",
          },
          {
            class: "Geografia (Prof. Dudu)",
            hour: "2024-10-28T19:30:00-03:00",
            url: "eZRONvJoedA",
          },
        ],
      },
      {
        date: "2024-10-29T00:00:00-03:00",
        title: "TERÇA - 29/10",
        ebookLink: "sos_aprova_dia_2",
        simulatedLink: "simulado-sos-2024-29-10",
        liveUrl: "zskOoBCwpRM",
        asset: "thumb-ter-1",
        classes: [
          { hour: "2024-10-29T15:00:00-03:00", class: 'Português (Prof. Ricardinho)', url: "zskOoBCwpRM" },
          { hour: "2024-10-29T16:00:00-03:00", class: 'Português (Profa. Carol Mendonça', url: "zskOoBCwpRM" },
          { hour: "2024-10-29T17:15:00-03:00", class: 'Sociologia (Profa. Daiana', url: "zskOoBCwpRM" },
          { hour: "2024-10-29T18:15:00-03:00", class: 'Geografia (Prof. Dudu)', url: "zskOoBCwpRM" },
          { hour: "2024-10-29T19:30:00-03:00", class: 'Redação (Profa. Carol e Profa. Dani', url: "zskOoBCwpRM" }
        ],
      },
      {
        date: "2024-10-30T00:00:00-03:00",
        title: "QUARTA - 30/10",
        ebookLink: "sos_aprova_dia_3",
        simulatedLink: "simulado-sos-2024-30-10",
        liveUrl: "5RTYyeL_umE",
        asset: "thumb-qua-1",
        classes: [
          {  hour: "2024-10-30T15:00:00-03:00", class: 'História (Prof. Alan)', url: "5RTYyeL_umE" },
          {  hour: "2024-10-30T16:00:00-03:00", class: 'Literatura (Profa. Camila)', url: "5RTYyeL_umE"},
          {  hour: "2024-10-30T17:15:00-03:00", class: 'Redação (Profa. Jana Rabelo)', url: "5RTYyeL_umE" },
          {  hour: "2024-10-30T18:15:00-03:00", class: 'Geografia (Prof. Victor)', url: "5RTYyeL_umE" },
          {  hour: "2024-10-30T19:30:00-03:00", class: 'Redação (Profa. Dani)', url: "5RTYyeL_umE"}
        ],
      },
      {
        date: "2024-10-31T00:00:00-03:00",
        title: "QUINTA - 31/10",
        ebookLink: "sos_aprova_dia_4",
        simulatedLink: "simulado-sos-2024-31-10",
        liveUrl: "txEOsiMx5BU",
        asset: "thumb-qui-1",
        classes: [
          { hour: "2024-10-31T15:00:00-03:00", class: 'História (Prof. Alan)', url: 'txEOsiMx5BU' },
          { hour: "2024-10-31T16:00:00-03:00", class: 'História (Prof. Dalton)', url: 'txEOsiMx5BU' },
          { hour: "2024-10-31T17:15:00-03:00", class: 'Português (Prof. Ricardinho)', url: 'txEOsiMx5BU' },
          { hour: "2024-10-31T18:15:00-03:00", class: 'Redação (Profa. Dani)', url: 'txEOsiMx5BU' },
          { hour: "2024-10-31T19:30:00-03:00", class: 'Geografia (Prof. Victor)', url: 'txEOsiMx5BU' }
        ],
      },
      {
        date: "2024-11-01T00:00:00-03:00",
        title: "SEXTA - 01/11",
        ebookLink: "sos_aprova_dia_5",
        simulatedLink: "simulado-sos-2024-01-11",
        liveUrl: "WlNxjESAhmg",
        asset: "thumb-sex-1",
        classes: [
          { hour: "2024-11-01T15:00:00-03:00", class: 'Literatura (Prof. Gui Suman)', url: 'WlNxjESAhmg' },
          { hour: "2024-11-01T16:00:00-03:00", class: 'História (Prof. Dalton)', url: 'WlNxjESAhmg' },
          { hour: "2024-11-01T17:15:00-03:00", class: 'Filosofia (Prof. Thiago Suman)', url: 'WlNxjESAhmg' },
          { hour: "2024-11-01T18:15:00-03:00", class: 'Redação (Profa. Dani)', url: 'WlNxjESAhmg' },
          { hour: "2024-11-01T19:30:00-03:00", class: 'Filosofia (Prof. Thiago Suman)', url: 'WlNxjESAhmg' },
        ],
      },
      {
        date: "2024-11-02T00:00:00-03:00",
        title: "SÁBADO - 02/11",
        liveUrl: "3Dl2FBqYcBk",
        simulatedLink: "simulado-sos-2024-02-11-sabado",
        ebookLink: "sos_aprova_sabado_1",
        asset: "thumb-sab-1",
        classes: [
          {
            class: "Aulão",
            hour: "2024-11-02T15:00:00-03:00",
            end: "2024-11-02T19:15:00-03:00",
            url: "3Dl2FBqYcBk",
          }
        ],
      },
      // {
      //   date: "2024-11-03T00:00:00-03:00",
      //   title: "DOMINGO - 03/11",
      //   liveUrl: "bJsphW8SZLo",
      //   asset: "thumb-dom",
      //   classes: [
      //     {
      //       class: "Cobertura e correção da prova do enem",
      //       hour: "2024-11-03T18:15:00-03:00",
      //       url: "bJsphW8SZLo",
      //     }
      //   ],
      // },
    ],
  },
  {
    week: 2,
    title: "SEMANA 2 - 04 A 10 de NOVEMBRO",
    subjects: ["Ciências da Natureza", "Matemática"],
    startDate: "2024-11-04T00:00:00-03:00",
    endDate: "2024-11-10T23:59:59-03:00",
    days: [
      {
        "date": "2024-11-04T00:00:00-03:00",
        "title": "SEGUNDA - 04/11",
        "ebookLink": "sos_aprova_dia_04_11",
        "simulatedLink": "simulado-sos-2024-04-11",
        "liveUrl": "x0W116cPgk",
        "asset": "thumb-seg-2",
        "classes": [
          {
            "class": "Biologia (Prof. Jubilut)",
            "hour": "2024-11-04T15:00:00-03:00",
            "url": "x0W116cPgk"
          },
          {
            "class": "Física (Prof. Grego)",
            "hour": "2024-11-04T16:00:00-03:00",
            "url": "x0W116cPgk"
          },
          {
            "class": "Matemática (Prof. Piu)",
            "hour": "2024-11-04T17:15:00-03:00",
            "url": "x0W116cPgk"
          },
          {
            "class": "Física (Prof. Grego)",
            "hour": "2024-11-04T18:15:00-03:00",
            "url": "x0W116cPgk"
          },
          {
            "class": "Química (Prof. Thiago)",
            "hour": "2024-11-04T19:30:00-03:00",
            "url": "x0W116cPgk"
          }
        ]
      },
      {
        "date": "2024-11-05T00:00:00-03:00",
        "title": "TERÇA - 05/11",
        "ebookLink": "sos_aprova_dia_05_11",
        "simulatedLink": "simulado-sos-2024-05-11",
        "liveUrl": "C4LAMTkhKyU",
        "asset": "thumb-ter-2",
        "classes": [
          {
            "class": "Biologia (Prof. Gustavo)",
            "hour": "2024-11-05T15:00:00-03:00",
            "url": "C4LAMTkhKyU"
          },
          {
            "class": "Física (Prof. Nilo)",
            "hour": "2024-11-05T16:00:00-03:00",
            "url": "C4LAMTkhKyU"
          },
          {
            "class": "Biologia (Prof. Gustavo)",
            "hour": "2024-11-05T17:15:00-03:00",
            "url": "C4LAMTkhKyU"
          },
          {
            "class": "Matemática (Prof. Naza)",
            "hour": "2024-11-05T18:15:00-03:00",
            "url": "C4LAMTkhKyU"
          }
        ]
      },
      {
        "date": "2024-11-06T00:00:00-03:00",
        "title": "QUARTA - 06/11",
        "ebookLink": "sos_aprova_dia_06_11",
        "simulatedLink": "simulado-sos-2024-06-11",
        "liveUrl": "LzevLap8yMg",
        "asset": "thumb-qua-2",
        "classes": [
          {
            "class": "Matemática (Prof. Piu)",
            "hour": "2024-11-06T15:00:00-03:00",
            "url": "LzevLap8yMg"
          },
          {
            "class": "Física (Prof. Nilo)",
            "hour": "2024-11-06T16:00:00-03:00",
            "url": "LzevLap8yMg"
          },
          {
            "class": "Matemática (Prof. Piu)",
            "hour": "2024-11-06T17:15:00-03:00",
            "url": "LzevLap8yMg"
          },
          {
            "class": "Biologia (Prof. Gustavo)",
            "hour": "2024-11-06T18:15:00-03:00",
            "url": "LzevLap8yMg"
          }
        ]
      },
      {
        "date": "2024-11-07T00:00:00-03:00",
        "title": "QUINTA - 07/11",
        "ebookLink": "sos_aprova_dia_07_11",
        "simulatedLink": "simulado-sos-2024-07-11",
        "liveUrl": "keSAjLg5_2E",
        "asset": "thumb-qui-2",
        "classes": [
          {
            "class": "Química (Prof. Guilherme)",
            "hour": "2024-11-07T15:00:00-03:00",
            "url": "keSAjLg5_2E"
          },
          {
            "class": "Física (Prof. Rossetto)",
            "hour": "2024-11-07T16:00:00-03:00",
            "url": "keSAjLg5_2E"
          },
          {
            "class": "Química (Prof. Guilherme)",
            "hour": "2024-11-07T17:15:00-03:00",
            "url": "keSAjLg5_2E"
          },
          {
            "class": "Física (Prof. Rossetto)",
            "hour": "2024-11-07T18:15:00-03:00",
            "url": "keSAjLg5_2E"
          },
          {
            "class": "Química (Prof. Thiago)",
            "hour": "2024-11-07T18:15:00-03:00",
            "url": "keSAjLg5_2E"
          }
        ]
      },
      {
        "date": "2024-11-08T00:00:00-03:00",
        "title": "SEXTA - 08/11",
        "ebookLink": "sos_aprova_dia_08_11",
        "simulatedLink": "simulado-sos-2024-08-11",
        "liveUrl": "EgKjfq2CHng",
        "asset": "thumb-sex-2",
        "classes": [
          {
            "class": "Biologia (Prof. Jubilut)",
            "hour": "2024-11-08T15:00:00-03:00",
            "url": "EgKjfq2CHng"
          },
          {
            "class": "Matemática (Prof. Vavá)",
            "hour": "2024-11-08T16:00:00-03:00",
            "url": "EgKjfq2CHng"
          },
          {
            "class": "Matemática (Prof. Vavá)",
            "hour": "2024-11-08T17:15:00-03:00",
            "url": "EgKjfq2CHng"
          },
          {
            "class": "Química (Prof. Guilherme)",
            "hour": "2024-11-08T18:15:00-03:00",
            "url": "EgKjfq2CHng"
          },
          {
            "class": "Matemática (Prof. Vavá)",
            "hour": "2024-11-08T19:30:00-03:00",
            "url": "EgKjfq2CHng"
          }
        ]
      },
      {
        date: "2024-11-09T00:00:00-03:00",
        title: "SÁBADO - 09/11",
        liveUrl: "Wgxva9SysQo",
        simulatedLink: "simulado-sos-2024-09-11-sabado",
        ebookLink: "sos_aprova_sabado_2",
        asset: "thumb-sab-2",
        classes: [
          {
            class: "Aulão",
            hour: "2024-11-09T15:00:00-03:00",
            end: "2024-11-09T19:15:00-03:00",
            url: "Wgxva9SysQo",
          }
        ],
      },
      // {
      //   date: "2024-11-10T00:00:00-03:00",
      //   title: "DOMINGO - 10/11",
      //   liveUrl: "r8WsDVK6yaI",
      //   asset: "thumb-dom",
      //   classes: [
      //     {
      //       class: "Cobertura e correção da prova do enem",
      //       hour: "2024-11-10T18:15:00-03:00",
      //       url: "r8WsDVK6yaI",
      //     },
      //   ],
      // },
    ],
  },
];